import LayoutContainer from "containers/Layout/LayoutContainer";
import { CustomerRoute, OnboardingRoute } from "helper/route";
import { getPhcPreviewAuthFromLocation } from "helper/phcPreviewAuthToken";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Redirect, Switch, useLocation } from "react-router-dom";
import PhcOnboardingNavigator from "./PhcOnboardingNavigator";
import Dashboard from "pages/PHC/Dashboard/Dashboard";

const PhcNavigator = (props) => {
  const { match } = props;
  const location = useLocation();

  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated,
  );

  const previewAuth = useMemo(
    () => getPhcPreviewAuthFromLocation(location.pathname, location.search),
    [location.pathname, location.search],
  );

  const onboardingRouteAuthenticated =
    isAuthenticated || Boolean(previewAuth?.token);

  // Product onboaridng completed
  const isPortfolioOnboardingCompleted = useSelector(
    (state) => state.onboarding.isOnboardingCompleted,
  );
  const isRMSonboardingCompleted = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.isOnboardingCompleted,
  );
  const isOnestockonboardingCompleted = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted,
  );
  const isPrimeonboardingCompleted = useSelector(
    (state) => state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted,
  );
  const isSentimentTrackerOnboardingCompleted = useSelector(
    (state) =>
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted,
  );

  const isPhcOnboardingCompleted = useSelector(
    (state) => state.PHC.PHCOnboarding.isOnboardingCompleted,
  );

  const anyOnboardingCompleted =
    isPortfolioOnboardingCompleted ||
    isRMSonboardingCompleted ||
    isOnestockonboardingCompleted ||
    isPrimeonboardingCompleted ||
    isSentimentTrackerOnboardingCompleted ||
    isPhcOnboardingCompleted;

  const redirectTo = () => {
    let restPath = "dashboard";
    if (!isPhcOnboardingCompleted) {
      restPath = "onboarding/overview";
    }

    return `${match.path}/${restPath}`;
  };

  return (
    <Switch>
      <Redirect exact from={match.path} to={redirectTo()} />
      <OnboardingRoute
        isAuthenticated={onboardingRouteAuthenticated}
        isOnboardingCompleted={isPhcOnboardingCompleted}
        // redirectOnboardingIncomplete={`${match.path}/dashboard`} // old code to redirect if any onboarding completed  
        redirectOnboardingCompleted={`/customer/dashboard`} // new code to redirect if any onboarding completed 
        path={`${match.path}/onboarding`}
        component={PhcOnboardingNavigator}
      />
      <LayoutContainer {...props}>
        <Switch>
          <CustomerRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={anyOnboardingCompleted}
            redirectOnboardingCompleted={`${match.path}/onboarding`}
            path={`${match.path}/dashboard`}
            component={Dashboard}
          />
        </Switch>
      </LayoutContainer>
    </Switch>
  );
};

export default PhcNavigator;
